
import { defineComponent, ref } from 'vue'
import LayoutDownload from '@/layouts/LayoutDownload.vue'
import StrategyModal from '../StrategyModal.vue'
import Header from '../Header.vue'
export default defineComponent({
  name: 'OutBox',
  emits: ['open'],
  props: ['time'],
  components: {
    LayoutDownload,
    StrategyModal,
    Header
  },
  setup() {
    const strategyModal = ref(false)
    const { body } = document

    const showStrategyModal = () => {
      strategyModal.value = true
      body.classList.add('locked')
    }

    const hideStrategyModal = () => {
      strategyModal.value = false
      body.classList.remove('locked')
    }

    return {
      strategyModal,
      showStrategyModal,
      hideStrategyModal
    }
  }
})
